<div *ngIf="alertVm$ | async as vm" [ngClass]="vm.alertClass" class="ontario-alert">
  <div class="ontario-alert__header" role="alert">
    <div class="ontario-alert__header-icon">
      <img [src]="vm.iconName" alt="Alert Type" aria-hidden="true" />
    </div>
    <h2 *ngIf="!small" class="ontario-alert__header-title ontario-h4" tabindex="0">{{ vm.alert.title }}</h2>
    <h4 *ngIf="small" class="ontario-alert__header-title ontario-h6" tabindex="0">{{ vm.alert.title }}</h4>
    <div *ngIf="vm.alert.closeable" class="close-alert">
      <button mat-icon-button matTooltip="Clear Alert" aria-label="Clear Alert" (click)="clearAlert()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div *ngIf="vm.alert.message?.trim()" class="ontario-alert__body" role="alert">
    <!-- <p>{{alert.message}}</p> -->
    <p [innerHTML]="vm.alert.message"></p>
  </div>
</div>
